{
	"title": "Medal tally",
	"subtitle": "{{games}}. Ranked by gold, then silver, then bronze. Click a NOC to see its medals.",
	"filters": {
		"label": "Medal filters",
		"sport": "Sport",
		"allSports": "All sports",
		"noc": "NOC",
		"allNocs": "All NOCs"
	},
	"medal": {
		"GOLD": "Gold",
		"SILVER": "Silver",
		"BRONZE": "Bronze"
	},
	"tally": {
		"title": "Medals by NOC",
		"titleInSport": "Medals by NOC in {{sport}}",
		"rank": "Rank",
		"noc": "NOC",
		"gold": "Gold",
		"silver": "Silver",
		"bronze": "Bronze",
		"total": "Total",
		"awarded_one": "{{n}} medal awarded:",
		"awarded_other": "{{n}} medals awarded:",
		"open": "Show the medals of {{noc}}",
		"noneAwarded": "No medal has been awarded in this games yet. Every NOC taking part is listed with zeros.",
		"noneAwardedInSport": "No medal has been awarded in {{sport}} yet. Every NOC entered in it is listed with zeros.",
		"emptyTitle": "No NOCs yet",
		"emptyBody": "NOCs appear here once their competitors are entered in this games."
	},
	"list": {
		"latest": "Latest medals",
		"ofNoc": "Medals of {{noc}}",
		"inSport": "Medals in {{sport}}",
		"ofNocInSport": "Medals of {{noc}} in {{sport}}",
		"medal": "Medal",
		"event": "Event",
		"sport": "Sport",
		"noc": "NOC",
		"competitor": "Athlete or team",
		"awarded": "Awarded",
		"showing_one": "Showing {{n}} medal",
		"showing_other": "Showing {{n}} medals",
		"showingOf_one": "Showing {{n}} of {{total}} medal",
		"showingOf_other": "Showing {{n}} of {{total}} medals",
		"more": "Next {{n}}",
		"allLoaded": "All medals are shown.",
		"clearNoc": "Show every NOC",
		"emptyTitle": "No medals yet",
		"emptyBody": "Medals appear here once the medal desk awards them.",
		"emptyFilteredTitle": "No medals match",
		"emptyFilteredBody": "No medal has been awarded for this choice yet. Pick another sport or NOC.",
		"reset": "Clear filters"
	},
	"errors": {
		"gamesTitle": "The games could not be loaded"
	},
	"empty": {
		"noGamesTitle": "No games yet",
		"noGamesBody": "Medals show here once a games is set up in GMS."
	},
	"desk": {
		"loading": "Loading the podium…",
		"title": "Medals: {{event}}",
		"awardedSubtitle": "Awarded by the medal desk (MSES). The portal and the medal table show these medals.",
		"notAwardedSubtitle": "The medal desk (MSES) awards the medals. OVR suggests the podium below.",
		"openInMses": "Open in MSES",
		"current": "On the podium",
		"noneYet": "No medal awarded yet. Until then the portal shows this event as not decided.",
		"lockedNote": "The medal desk locked this event: results are frozen until it is unlocked in MSES.",
		"suggestionTitle": "Suggested podium",
		"suggestionDecided": "Every medal meet is official. This is what the results point to.",
		"waitingSubtitle": "{{official}} of {{total}} medal meets are official.",
		"noSuggestion": "No podium yet: the medal meets have no official result.",
		"notSent": "Not sent to the medal desk yet.",
		"sentSame": "The medal desk has this suggestion.",
		"sentDiffers": "The medal desk has an older suggestion. Send this one to update it.",
		"send": "Send to medal desk",
		"resend": "Send update to medal desk",
		"sentToast": "Suggestion sent to the medal desk.",
		"lockedNoSend": "Locked events take no new suggestion.",
		"notAllOfficial": "Only {{official}} of {{total}} medal meets are official. Check the results before you send."
	}
}
